import React from 'react';
import ReportTemplateModel, { ReportTemplateModelNames } from './ReportTemplateModel';

const LayoutsList = () => {
    return (
        <ReportTemplateModel
            modelName={ReportTemplateModelNames.Layout}
        />
    );
}
export default React.memo(LayoutsList);
